/**
 * @desc getStockAgeList
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.wms.StockAgeRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/stockAge/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
